<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === transactionAdminFilterKey.Status) {
      <mat-selection-list [formField]="formTree.status">
        @for (status of transactionStatusValues; track $index) {
          <mat-list-option [value]="status" (click)="$event.stopPropagation()">
            {{ status | transactionStatusDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
